import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M9 13.714a4.714 4.714 0 1 0 0-9.428 4.714 4.714 0 0 0 0 9.428M9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M10.927 7.427a.25.25 0 1 0-.354-.354L9 8.646 7.427 7.073a.25.25 0 0 0-.354.354L8.647 9l-1.574 1.573a.25.25 0 0 0 .354.354L9 9.354l1.573 1.573a.25.25 0 0 0 .354-.354L9.354 9z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  d: "m10.927 7.073-.177.177zm0 .354-.177-.177zm-.354-.354-.176-.177zM9 8.646l-.177.177a.25.25 0 0 0 .354 0zM7.427 7.073l-.177.177zm-.354 0 .177.177zm0 .354.177-.177zM8.647 9l.176.177a.25.25 0 0 0 0-.354zm-1.574 1.573.177.177zm0 .354.177-.177zm.354 0-.177-.177zM9 9.354l.177-.177a.25.25 0 0 0-.354 0zm1.573 1.573.177-.177zm.354 0-.177-.177zm0-.354-.177.177zM9.354 9l-.177-.177a.25.25 0 0 0 0 .354zm1.396-1.75.354.354a.5.5 0 0 0 0-.708zm0 0 .354-.354a.5.5 0 0 0-.707 0zM9.177 8.823 10.75 7.25l-.353-.354L8.823 8.47zM7.25 7.25l1.573 1.573.354-.353-1.573-1.574zm0 0 .354-.354a.5.5 0 0 0-.708 0zm0 0-.354-.354a.5.5 0 0 0 0 .708zm1.573 1.573L7.25 7.25l-.354.354L8.47 9.177zM7.25 10.75l1.573-1.573-.353-.354-1.574 1.573zm0 0-.354-.354a.5.5 0 0 0 0 .708zm0 0-.354.354a.5.5 0 0 0 .708 0zm1.573-1.573L7.25 10.75l.354.354L9.177 9.53zm1.927 1.573L9.177 9.177l-.354.353 1.574 1.574zm0 0-.353.354a.5.5 0 0 0 .707 0zm0 0 .354.354a.5.5 0 0 0 0-.708zM9.177 9.177l1.573 1.573.354-.354L9.53 8.823zM10.75 7.25 9.177 8.823l.354.354 1.573-1.573z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-error"}) } }